import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  Group,
  Stack,
  Text,
  Badge,
  ScrollArea,
} from "@mantine/core";
import { Trophy, CalendarBlank } from "@phosphor-icons/react";
import { HealthRiskAssessmentModal } from "./health-risk-assement-modal";

const knowledgeQuizzes = [
  {
    title: "Heart Health Basics",
    questions: 5,
    points: 25,
    status: "Not Started",
    buttonLabel: "Start Quiz",
  },
  {
    title: "Blood Pressure Management",
    questions: 4,
    points: 15,
    status: "Completed",
    score: "3/4",
    buttonLabel: "Retake",
  },
  {
    title: "Stress and Mental Health",
    questions: 6,
    points: 30,
    status: "In Progress",
    buttonLabel: "Continue",
  },
];

const generalQuestionnaires = [
  {
    title: "Bone & Joint Health",
    questions: 6,
    points: 30,
  },
  {
    title: "Nutrition & Balanced Diet",
    questions: 5,
    points: 25,
  },
  {
    title: "Sleep & Recovery",
    questions: 4,
    points: 20,
  },

  {
    title: "Bone & Joint Health",
    questions: 6,
    points: 30,
  },
  {
    title: "Nutrition & Balanced Diet",
    questions: 5,
    points: 25,
  },
  {
    title: "Sleep & Recovery",
    questions: 4,
    points: 20,
  },
  {
    title: "Bone & Joint Health",
    questions: 6,
    points: 30,
  },
  {
    title: "Nutrition & Balanced Diet",
    questions: 5,
    points: 25,
  },
  {
    title: "Sleep & Recovery",
    questions: 4,
    points: 20,
  },
];

const KnowledgeCheck: React.FC = () => {
  const [opened, setOpened] = useState(false);

  return (
    <div>
      <Text fw={600} mb="md" size="lg" mt="md">
        Knowledge Check
      </Text>

      <Stack>
        {knowledgeQuizzes.map((quiz, index) => (
          <Card withBorder radius="md" key={index}>
            <Group justify="space-between" align="flex-start">
              <Box>
                <Text fw={500}>{quiz.title}</Text>
                <Text size="sm" c="dimmed">
                  {quiz.questions} questions
                </Text>

                <Group gap="xs" mt="xs">
                  {quiz.status === "Completed" ? (
                    <>
                      <Group gap="xs" mt={15}>
                        <CalendarBlank size={16} />
                        <Text size="sm" fw={500}>
                          Score: {quiz.score}
                        </Text>
                      </Group>

                      <Group gap="xs" mt={15}>
                        <Trophy size={16} />
                        <Text size="sm">{quiz.points}pts earned</Text>
                      </Group>
                    </>
                  ) : (
                    <Group gap="xs" mt={15}>
                      <Trophy size={16} />
                      <Text size="sm">Earn up to {quiz.points}pts</Text>
                    </Group>
                  )}
                </Group>
              </Box>

              <Stack align="flex-end" justify="space-between" h="100%">
                <Badge
                  variant="light"
                  color={
                    quiz.status === "Completed"
                      ? "blue"
                      : quiz.status === "In Progress"
                        ? "violet"
                        : "gray"
                  }
                >
                  {quiz.status}
                </Badge>

                <Button
                  variant={
                    quiz.status === "Not Started" ? "gradient" : "outline"
                  }
                  size="xs"
                  mt="lg"
                  styles={{
                    root: quiz.status === "Not Started" ? {
                      background: "linear-gradient(90deg, #0b36b0 0%, #6b3a91 40%, #ff7373 100%)",
                      border: "none",
                      color: "white",
                    } : undefined,
                  }}
                >
                  {quiz.buttonLabel}
                </Button>
              </Stack>
            </Group>
          </Card>
        ))}
      </Stack>
      <Box>
        <Text fw={600} mb="sm" size="lg" mt="sm">
          General Questionnaires
        </Text>
        <ScrollArea type="always" scrollbarSize={4} w="calc(100vw - 285px)">
          <Group gap="md" wrap="nowrap">
            {generalQuestionnaires.map((q, index) => (
              <Card
                withBorder
                radius="md"
                key={index}
                style={{ minWidth: 600 }}
              >
                <Stack>
                  <Box>
                    <Text fw={500}>{q.title}</Text>

                    <Group gap="xs" mt="xs" justify="space-between">
                      <Text size="sm" c="dimmed">
                        {q.questions} questions
                      </Text>

                      <Group gap="xs">
                        <Trophy size={16} />
                        <Text size="sm">Earn up to {q.points} pts</Text>
                      </Group>
                    </Group>
                  </Box>

                  <Button
                    fullWidth
                    size="xs"
                    onClick={() => setOpened(true)}
                    styles={{
                      root: {
                        background: "linear-gradient(90deg, #0b36b0 0%, #6b3a91 40%, #ff7373 100%)",
                        border: "none",
                        color: "white",
                      },
                    }}
                  >
                    Start Quiz
                  </Button>
                </Stack>
              </Card>
            ))}
          </Group>
        </ScrollArea>
      </Box>
      <HealthRiskAssessmentModal opened={opened} onClose={() => setOpened(false)} />
    </div>
  );
};

export default KnowledgeCheck;
